import useDefinedContext from "hooks/useDefinedContext";
import { CarouselActionsContext } from "../../Carousel";

/**
 * @important
 * This hook should only be used inside the Carousel component.
 */
function useCarouselActions() {
  return useDefinedContext(CarouselActionsContext);
}

export default useCarouselActions;
